module.exports = __webpack_public_path__ + "static/media/texture.7b81025e.svg";